export const colorBrandDark = "rgb(0, 45, 110)";
export const colorBrandTwilight = "rgb(0, 68, 176)";
export const colorBrand = "rgb(0, 80, 207)";
export const colorBrand1 = "rgb(0, 80, 207)";
export const colorBrand2 = "rgb(58, 116, 208)";
export const colorBrand3 = "rgb(142, 178, 236)";
export const colorBrand4 = "rgb(194, 218, 255)";
export const colorBrand5 = "rgb(240, 245, 255)";